import React from 'react';
//import PropTypes from 'prop-types';
import Anchor from 'grommet/components/Anchor';
import AppWrapper from 'grommet/components/App';
import Box from 'grommet/components/Box';
import Header from 'grommet/components/Header';
import Image from 'grommet/components/Image';
import Menu from 'grommet/components/Menu';
import Button from 'grommet/components/Button';
import Footer from 'grommet/components/Footer';
import Title from 'grommet/components/Title';
import SocialTwitterIcon from 'grommet/components/icons/base/SocialTwitter';
import SocialGithubIcon from 'grommet/components/icons/base/SocialGithub';

//Redux
//import { connect } from 'react-redux';
//import { sendMessages } from '../actions';

class App extends React.Component {
/*   responsive={false}
  icon={<Actions />}
  label='Label'
  inline={true}
  primary={true}
  direction='row'
  size='large' */
  _onClick(event) {
    if (event === "twitter") {
      window.open("https://twitter.com/Prophesierstat");
    } else if (event === "github") {
      window.open("https://github.com/prophesierstatistics/prophesierstatistics.github.io");
    }
  }
  render() {
    //console.log(this.props.children);
    //img/hpe-brandcentral-logo.png

    return (
	<AppWrapper inline={false} centered={false}>
      <Box direction="row" justify="between" full="horizontal">
        <Header justify="start" colorIndex="light" pad={{"horizontal": "medium"}} role="nav">
          <div style={{marginRight: "10px"}}>
            <Image src="./prophesierlogo.png" size="thumb" />
          </div>
          <Title>
            In-browser Data Preparation Tool
            <small style={{fontSize: "12px"}}>Beta</small>
          </Title>
        </Header>
       
        <Box direction="row" justify="end" align="center" pad={{"horizontal":"small"}} size={{"width": {"min":"medium"}}} flex="grow">
        </Box>
      </Box>
      {(!window.location.href.includes("https://prophesierstatistics.github.io/custom")) ? <Box direction="row" wrap={true} appCentered={true} colorIndex="accent-2" pad={{ horizontal: 'medium' }}  >
          <Menu fill={true} responsive={false} label="Menu" inline={true} direction="row">
            <Anchor style={{ fontSize: '16px'}} id={"1"} href="/">
              Home
            </Anchor>
           {/*  <Anchor style={{ fontSize: '16px'}} id={"1"} href="/workflow">
              Models
            </Anchor> */}
           {/*  <Anchor style={{ fontSize: '16px'}} id={"2"} href="/developer">
              Live Edit
            </Anchor>
            
            <Anchor style={{ fontSize: '16px'}} id={"3"} href="mailto:fredygomez1981@gmail.com">
              Contact 
            </Anchor> */}            
          </Menu>
          {/* <Box pad={"small"}>
            <SocialTwitterIcon onClick={this._onClick.bind(this, "twitter")} style={{cursor: "pointer"}}/>
          </Box>*/}
          <Box pad={"small"}>
            <SocialGithubIcon onClick={this._onClick.bind(this, "github")} style={{cursor: "pointer"}}/>
          </Box> 
        </Box> : null}
        <Box>
          {this.props.children}
        </Box>
      
	  {(!window.location.href.includes("https://prophesierstatistics.github.io/custom")) ? <Footer primary={true} appCentered={true} direction="column" align="center" pad="small" colorIndex="accent-2">
	    <Box direction="row" align="stretch">
          <Box alignContent="start" align="center" pad={{"horizontal": "medium"}}>
            © 2019 Copyright
          </Box>
          {/* <Box alignContent="end" align="center" pad={{"horizontal": "medium"}}>
            <Anchor href="https://www.google.com/#q=about" label="About"/>
          </Box>
          <Box alignContent="end" align="center" pad={{"horizontal": "medium"}}>
            <Anchor href="https://facebook.github.io/react/" label="google"/>
          </Box>
          <Box alignContent="end" align="center" pad={{"horizontal": "medium"}}>
            <Anchor href="https://www.google.com/#q=terms"label="Terms"/>
          </Box>
          <Box alignContent="end" align="center" pad={{"horizontal": "medium"}}>
            <Anchor href="https://www.google.com/#q=privacy"label="Privacy"/>
          </Box> */}
        </Box>
	  </Footer> : null}
	</AppWrapper>
	  );
  }
};


/*
App.propTypes = {
  view: PropTypes.array.isRequired,
  trbl: PropTypes.array.isRequired,
  names: PropTypes.array.isRequired,
  offset: PropTypes.string.isRequired,
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired,
  mounted: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
};
*/

const mapStateToProps = state => {
  const { AppState } = state;
  return {
    AppState
  };
};

//export default connect(mapStateToProps)(App);

export default App;


/*
      <div className="App">
        <div className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h2>Welcome to React</h2>
        </div>
        <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p>
      </div>
*/


// WEBPACK FOOTER //
// ./src/containers/App.js